<template>
    <div :class="preCls + 'content-box'">
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <Select
                style="width: 100px; margin-right: 20px"
                v-model="filter.invoiceType"
                placeholder="发票类型"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in dict.invoiceType.toList()"
                    :value="item.text"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <!-- 列表工具栏 -->
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.purchaser"
                    placeholder="请输入购方名称"
                    style="margin-left: 10px"
                    @search="search"
                >
                    搜索
                </table-searcher>
            </template>
            <Button
                v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
            >
                新增
            </Button>
            <Button
                v-if="$can('view')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>

        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    v-if="$can('view')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickView(row)"
                >
                    详情
                </Button>

                <Button
                    v-if="$can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickUpdate(row)"
                >
                    修改
                </Button>
                <PoptipButton
                    v-if="$can('delete')"
                    text="删除"
                    transfer
                    placement="top-end"
                    type="default"
                    title="您确定删除这条记录吗？"
                    :ok="() => rowClickDelete(row)"
                />
            </template>

            <template v-slot:invoiceType="{ row }">
                {{ dict.invoiceType.val(row.invoiceType) }}
            </template>
        </Table>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showInvoiceForm"
            :title="actionTitle + '发票'"
            :width="800"
            :height="400"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <i-invoice-form
                v-if="modal.showInvoiceForm"
                :invoiceId="curId"
                :actionType="actionType"
            />
        </smart-modal>

        <table-pager
            :total="page.totalCount"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.page"
            @change="fetch"
        >
        </table-pager>
    </div>
</template>
<script>
import { invoiceList, invoiceDelete } from '@/api/invoice'
import { mapCache } from '@/plugins/vux-data-cache'
import { pipeCell } from '_c/grid/renderCell'
import iInvoiceForm from './i-invoice-form'
import FilterDateRange from '_v/components/filter/filter-date-range'

import dayjs from 'dayjs'
import { ymd } from '_u/helper'
const PAGE_SIZE = 20
export default {
    name: 'i-invoice-list',
    components: {
        iInvoiceForm,
        FilterDateRange,
    },
    data() {
        return {
            curId: '',
            actionType: '', // 1 新增; 2 查看; 3 修改;
            dict: {
                invoiceType: this.$dict.NULL,
                actionType: this.$dict.NULL,
            },
            modal: {
                showInvoiceForm: false,
            },
            page: {
                totalCount: 0,
                list: [],
            },
            loading: false,
            mtHeight: 360,
        }
    },
    computed: {
        ...mapCache({
            filter: 'invoiceFilter', //将要缓存的改成本地命名
        }),
        columns() {
            return [
                {
                    type: 'index',
                    width: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    title: '购方名称',
                    key: 'purchaser',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true,
                },
                {
                    title: '业务名称',
                    key: 'busName',
                    align: 'left',
                    minWidth: 120,
                },
                {
                    title: '发票类型',
                    key: 'invoiceType',
                    align: 'center',
                    minWidth: 120,
                    slot: 'invoiceType',
                },
                {
                    title: '合计金额(元)',
                    key: 'totalAmount',
                    align: 'right',
                    minWidth: 120,
                    render: pipeCell('currency'),
                },
                {
                    title: '价税合计(元)',
                    key: 'amount',
                    align: 'right',
                    minWidth: 120,
                    render: pipeCell('currency'),
                },
                {
                    title: '开票日期',
                    key: 'invoiceTime',
                    align: 'center',
                    minWidth: 120,
                    render: pipeCell('ymd'), //使用全局filter转化成格式化的数据
                },

                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 170,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },

        actionTitle() {
            return this.dict.actionType.val(this.actionType)
        },
    },
    methods: {
        fetch() {
            this.loading = true
            Promise.all([
                invoiceList(this.filter),
                this.$dict.get(['invoice_type', 'action_type']),
            ])
                .then((args) => {
                    var [view, group] = args

                    Object.assign(this.dict, group)

                    view.data.page.list.forEach((v) => {
                        v.totalAmount /= 100
                        v.amount /= 100
                    })
                    this.page.list = view.data.page.list
                    this.page.totalCount = parseInt(view.data.page.totalCount)
                })
                .finally(() => (this.loading = false))
        },
        search() {
            this.filter.page = 1
            this.fetch()
        },

        // 导出数据处理
        onClickExport() {
            this.$refs.mt.exportToExcel({
                rows: this.page.list.map((data, index) => {
                    let pageData = Object.assign({}, data)
                    pageData.invoiceTime = ymd(pageData.invoiceTime)
                    return pageData
                }),
            })
        },
        onClickAdd() {
            this.actionType = '1'
            this.curId = ''
            this.modal.showInvoiceForm = true
        },

        rowClickView(row) {
            this.actionType = '2'
            this.curId = row.id
            this.modal.showInvoiceForm = true
        },

        rowClickUpdate(row) {
            this.actionType = '3'
            this.curId = row.id
            this.modal.showInvoiceForm = true
        },
        rowClickDelete(row) {
            this.loading = true
            invoiceDelete(row.id)
                .then((args) => this.$Message.success('删除成功'))
                .then((res) => this.fetch())
                .finally(() => {
                    this.loading = false
                })
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
}
</script>
